import 'C:\\Projects\\genkei\\zumeco\\static\\doodle\\user-cursor\\UserCursors.ts.esbuild-plugin-windicss.css';
import type { DoodleUser } from '../../../server/src/models';
import { i18n } from '../../shared/i18n';
import { getScale } from '../view/CanvasContainer';
import './user-cursor.css';
const collectionInterval = 100;
const originElementSelector = '#doodle-canvas';
class UserCursor {
  readonly element: HTMLElement;
  private readonly intervalId: ReturnType<typeof setTimeout>;
  private page = 1;
  private currentUserPage = 1;
  private points: (readonly [number, number])[] = [];
  private readonly updatePageContent: () => void;
  constructor({
    color,
    text
  }: {
    readonly color: string;
    readonly text: string;
  }) {
    const cursor = this.element = document.body.appendChild(document.createElement('div'));
    cursor.className = 'user-cursor';
    cursor.style.transitionDuration = `${collectionInterval}ms`;
    {
      const svg = cursor.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
      svg.setAttribute('class', 'user-cursor-icon');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('fill', color);
      const polygon = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'polygon'));
      polygon.setAttribute('points', '0 16 0 0 12 12 5 12 0 17');
    }
    {
      const div = cursor.appendChild(document.createElement('div'));
      div.className = 'user-cursor-text';
      div.textContent = text;
      div.style.backgroundColor = color;
      const pageElement = div.appendChild(document.createElement('span'));
      pageElement.className = 'user-cursor-page';
      this.updatePageContent = () => pageElement.textContent = this.page === this.currentUserPage ? '' : i18n.userCursorPageTemplate(this.page);
    }
    this.intervalId = setInterval(() => {
      const p = this.points.shift();
      if (p) {
        cursor.style.left = `${p[0] + document.documentElement.scrollLeft + document.body.scrollLeft}px`;
        cursor.style.top = `${p[1] + document.documentElement.scrollTop + document.body.scrollTop}px`;
      }
    }, collectionInterval);
  }
  destroy() {
    document.body.removeChild(this.element);
    clearInterval(this.intervalId);
  }
  pushPoints(page: number, points: (readonly [number, number])[]) {
    this.page = page;
    this.points = points;
    this.updatePageContent();
  }
  setCurrentUserPage(page: number) {
    this.currentUserPage = page;
    this.updatePageContent();
  }
}
class UserCursors {
  private cursors = new Map<string, UserCursor>();
  add(user: DoodleUser) {
    const cursor = new UserCursor({
      color: user.color,
      text: user.name || user.email.replace(/@.*/, '')
    });
    cursor.element.style.display = user.active ? '' : 'none';
    this.cursors.set(user.uid, cursor);
  }
  clear() {
    for (const cursor of this.cursors.values()) {
      cursor.destroy();
    }
    this.cursors.clear();
  }
  show(user: DoodleUser) {
    const cursor = this.cursors.get(user.uid);
    if (cursor) {
      cursor.element.style.display = user.active ? '' : 'none';
    } else {
      this.add(user);
    }
  }
  setCurrentUserPage(page: number) {
    this.cursors.forEach(cursor => cursor.setCurrentUserPage(page));
  }
  pushPoints(uid: string, page: number, points: readonly (readonly [number, number])[]) {
    const origin = document.querySelector(originElementSelector)?.getBoundingClientRect();
    if (origin) {
      const scale = getScale();
      this.cursors.get(uid)?.pushPoints(page, points.map(p => [p[0] * scale + origin.left, p[1] * scale + origin.top]));
    }
  }
}
export const userCursors = new UserCursors();
export class CurrentUserCursor {
  private notificationInterval!: number;
  private notificationIntervalId?: number;
  private points: [number, number][] = [];
  constructor(readonly callback: (points: readonly (readonly [number, number])[]) => void) {
    if (!window.matchMedia?.('(hover:hover)')) {
      return;
    }
    const point: [number, number] = [-1, -1];
    addEventListener('pointermove', event => {
      point[0] = Math.round(event.clientX);
      point[1] = Math.round(event.clientY);
    });
    setInterval(() => this.points.push([point[0], point[1]]), collectionInterval);
    this.setNotificationInterval(1000);
  }
  setNotificationInterval(interval: number) {
    if (this.notificationInterval === interval) {
      return;
    }
    this.notificationInterval = interval;
    let lastPoint: [number, number] = [NaN, NaN];
    this.notificationIntervalId !== undefined && clearInterval(this.notificationIntervalId);
    this.notificationIntervalId = interval ? setInterval(() => {
      if (this.points.some(p => p[0] !== lastPoint[0] || p[1] !== lastPoint[1])) {
        lastPoint = [...this.points[this.points.length - 1]];
        const originElement = document.querySelector(originElementSelector);
        if (originElement) {
          const origin = originElement.getBoundingClientRect();
          const scale = getScale();
          this.callback(this.points.map(p => [Math.round((p[0] - origin.left) / scale + originElement.scrollLeft), Math.round((p[1] - origin.top) / scale + originElement.scrollTop)]));
        }
      }
      this.points = [];
    }, interval) : undefined;
  }
}